import { Box, CircularProgress, Link, Paper, Stack, Theme, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import useAfasData from "../hooks/useAfasData";
import LeaveSummary from "./Leave/LeaveSummary";
import { LeaveBalance, LeaveSummary as LeaveSummaryType } from "../types/types";
import LeaveDetails from "./Leave/LeaveDetails";
import { LanguageContext } from "../context/LanguageContext";

const LeaveComponent = () => {
  const { strings } = useContext(LanguageContext);
  const [overview, setOverview] = useState(true);
  const [leave, setLeave] = useState<LeaveSummaryType | null>(null);
  const { data: leaveData, isLoading: leaveLoading } = useAfasData("/leave/overview");
  useEffect(() => {
    if (!leaveLoading && leaveData) {
      leaveData.details.sort((a: LeaveBalance, b: LeaveBalance) => {
        return a.name.localeCompare(b.name);
      });
      setLeave(leaveData);
    }
  }, [leaveData]);

  return (
    <Paper
      elevation={0}
      sx={(theme: Theme) => ({
        height: "100%",
        bgcolor: theme.palette.light.main,
        py: 4,
        px: 3,
      })}
    >
      <Stack
        direction={"column"}
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Stack
            direction={"row"}
            sx={{
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 4,
            }}
          >
            <Typography variant="h3" component="h3">
              {strings.leave.title}
            </Typography>
            <Link
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              color="inherit"
              onClick={() => setOverview(!overview)}
            >
              {`${overview ? strings.leave.viewmore : strings.leave.viewless}`} &gt;
            </Link>
          </Stack>
        </Box>

        {leaveLoading && !leave && (
          <Box mt={2} width={"64px"} height={"64px"}>
            <CircularProgress />
          </Box>
        )}

        {overview && leave && !leaveLoading && <LeaveSummary leave={leave} />}

        {!overview && leave && !leaveLoading && <LeaveDetails leave={leave} />}
      </Stack>
    </Paper>
  );
};

export default LeaveComponent;
